module.exports = __webpack_public_path__ + "media/images/iconSettings__inFrontOfAccent-f07790f8b7b9b0cb852ba74eba267608.png";